import "./About.css";
import "@fortawesome/fontawesome-free/css/all.min.css";


const Feature = ({ icon, title, text, highlight }) => (
  <div className={`feature-card ${highlight ? "highlight" : ""}`}>
    <div className="icon">{icon}</div>
    <h3>{title}</h3>
    <p>{text}</p>
  </div>
);

export default function About() {
  const features = [
  {
    icon: <i className="fa-solid fa-trophy"></i>,
    title: "Elite Competition",
    text: "Showcasing the finest engineering talents as they compete with innovation, teamwork, and precision to achieve ultimate victory.",
  },
  {
    icon: <i className="fa-solid fa-bolt"></i>,
    title: "Cutting-Edge Tests",
    text: "Highlighting creativity, endurance, and technical brilliance through challenges that push the boundaries of engineering excellence.",
  },
  {
    icon: <i className="fa-solid fa-user-group"></i>,
    title: "Professional Environment",
    text: "AGKC delivers a clean, modern, and professional environment designed with user-centric principles to ensure a smooth, efficient, and engaging experience for all.",
  },
  {
    icon: <i className="fa-solid fa-bullseye"></i>,
    title: "Precision Matters",
    text: "Every design, detail, and motion reflects the accuracy, discipline, and perfection that define true motorsport engineering.",
  },
];

  return (
    <section id="about" className="about container">
      <h2 className="section-title">About the Championship</h2>
      <p className="lead">
        Welcome to the thrilling world of Go-Karting, where speed meets precision!
        The Aditya Institute of Technology and Management (AITAM), Tekkali, proudly
        presents the <span className="high"> AITAM's GoKarting Championship – Season III - Special edition.</span> An
        adrenaline-filled experience where every lap brings passion and performance to life.
      </p>

      <div className="features">
        {features.map((f, i) => (
          <Feature key={i} {...f} />
        ))}
      </div>

      <div className="stats-container">
        <div className="stat-box">
          <h2>10+</h2>
          <p>Challenging Tests</p>
        </div>
        <div className="stat-box">
          <h2>2</h2>
          <p>Seasons Completed</p>
        </div>
        <div className="stat-box">
          <h2>900+</h2>
          <p>Participants</p>
        </div>
      </div>
    </section>
  );
}
